export const LABEL_BOTAO_SEGUNDA_ASSINATURA = 'Assinar'

export const BASE_PROPRIEDADE_CATEGORIA_SEGUNDA_ASSINATURA = 'categoria'

export const BASE_PROPRIEDADE_BRINDE_SEGUNDA_ASSINATURA = 'brinde'

export const BASE_PROPRIEDADE_ENTREGA_SEGUNDA_ASSINATURA = 'entrega'

export const BASE_PROPRIEDADE_PAGAMENTO_SEGUNDA_ASSINATURA = 'pagamento'

export const BASE_PROPRIEDADE_PLANO_SEGUNDA_ASSINATURA = 'plano'

export const BASE_PROPRIEDADE_CUPONS_SEGUNDA_ASSINATURA = 'cupons'

export const BASE_PROPRIEDADE_PAGAMENTO_CARTAO_SEGUNDA_ASSINATURA = 'cartao_credito'

export const SUCESSO_FAZER_SEGUNDA_ASSINATURA_CARTAO = 'Segunda assinatura realizada com sucesso!'

export const SUCESSO_FAZER_SEGUNDA_ASSINATURA_PIX = 'A segunda assinatura será realizada assim que você fizer o pagamento do seu pix.'

export const BASES_OBRIGATORIAS_SEGUNDA_ASSINATURA = [
  BASE_PROPRIEDADE_CATEGORIA_SEGUNDA_ASSINATURA,
  BASE_PROPRIEDADE_BRINDE_SEGUNDA_ASSINATURA,
  BASE_PROPRIEDADE_ENTREGA_SEGUNDA_ASSINATURA,
  BASE_PROPRIEDADE_PAGAMENTO_SEGUNDA_ASSINATURA,
  BASE_PROPRIEDADE_PLANO_SEGUNDA_ASSINATURA
]

export const BASES_OPCIONAIS_SEGUNDA_ASSINATURA = [ BASE_PROPRIEDADE_CUPONS_SEGUNDA_ASSINATURA ]
